<template>
  <section v-if="lang.hotel_mobile_new">
    <Title :title-name="lang.hotel_mobile_new.SFS_LANG_ROW_26" :title-link="title.CancelHotelRoom.titleLink" />
    <div class="select_service select_service_option">
      <div class="container mt-4">
        <ItemOfVouchers icon="hotel-voucher" color="#f0725e" :label="lang['hotel_mobile_new'].SFS_LANG_ROW_1" border />
      </div>
      <div v-if="notExpiry" class="container my-4">
        <div class="sfs-wrapper-reason">
          <div class="ws-textbox">
            <div class="mb-3 title-decline-hotel">{{ lang['hotel_mobile_new'].SFS_LANG_ROW_18 }}</div>
            <div class="text-right">
              <i>0/200</i>
            </div>
            <textarea
              id="cancel-reason"
              v-model="cancelReason"
              class="form-control mb-2"
              name="cancel_reason"
              :aria-label="lang['hotel_mobile_new'].SFS_LANG_ROW_19 || 'Add a comment'"
              :placeholder="(lang['hotel_mobile_new'].SFS_LANG_ROW_19 || 'Add a comment') + '...'"
            ></textarea>
            <div>{{ lang['hotel_mobile_new'].SFS_LANG_ROW_20 }}</div>
            <div>{{ lang['hotel_mobile_new'].SFS_LANG_ROW_17 }}</div>
          </div>
          <div class="sfs-confirm-buttons text-center mt-4">
            <button
              class="ws-btn hd-normal-btn-background-color hd-normal-btn-color"
              :disabled="confirm"
              @click="cancelHotelVouchers"
            >
              {{ lang['hotel_mobile_new'].SFS_LANG_ROW_13 }}
            </button>
          </div>
        </div>
      </div>
      <div v-else class="container my-4">
        <div class="ws-textbox">
          {{ expiredText }}
        </div>
      </div>
      <b-modal v-model="isOpenPopup" :modal-class="'ws-modal'" centered hide-footer hide-header @hidden="onClosePopUp()">
        <div class="d-flex justify-content-center align-items-center flex-column py-5">
          <div class="icon-confirm-success">
            <i :class="[message.icon]"></i>
          </div>
          <div class="mt-3 h5">{{ message.text }}</div>
        </div>
      </b-modal>
    </div>
  </section>
</template>

<script>
import '@/assets/scss/modules/CancelHotelRoom.scss'
import Title from '@/components/Title/index'
import ItemOfVouchers from '@/components/ItemOfVouchers/index'
import { replaceStr } from '@/utils/helper'

export default {
  name: 'CancelHotelRoom',
  components: { Title, ItemOfVouchers },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      confirm: false,
      cancelReason: '',
      curPaxInfo: {},
      notExpiry: false,
      expiredText: 'this link has expired',
      isOpenPopup: false,
      message: {
        icon: '',
        text: ''
      },
      cancelHotelVouchersSuccess: false
    }
  },
  watch: {
    PaxsGroup: function () {
      if (!_.isEmpty(this.pax)) {
        this.initData()
      }
    },
    pax: function () {
      if (!_.isEmpty(this.PaxsGroup)) {
        this.initData()
      }
    },
    airline: function () {
      this.checkExpiredTime()
    }
  },
  created() {
    if (!_.isEmpty(this.pax) && !_.isEmpty(this.PaxsGroup)) {
      this.initData()
    }
  },
  mounted() {
    this.checkExpiredTime()
  },
  methods: {
    replaceStr,
    initData: function () {
      var self = this

      if (self.pax.has_cancelled_hotel_voucher) {
        // Has cancelled hotel voucher
        self.$router.push({ path: '/home', query: { secret: self.secret } })
        return
      }

      if (!self.pax.curPaxID && _.size(self.PaxsGroup) > 1 && this.$route.name != 'PaxContactConfirm') {
        // Don't know who are you
        self.$router.push({ path: '/pax-contact-confirm', query: { secret: self.secret } })
        return
      }

      self.curPaxInfo = _.find(self.PaxsGroup, function (pax) {
        return pax.passenger_id == self.pax.curPaxID
      })
    },
    checkExpiredTime: function () {
      let time_allow = Number(this.$route.query.ctime)
      if (time_allow > 0) {
        this.notExpiry = true
        let self = this
        setTimeout(function () {
          self.notExpiry = false
        }, time_allow * 1000)
      }
    },
    onClosePopUp: function () {
      if (this.cancelHotelVouchersSuccess) {
        this.$router.push({ path: '/home', query: { secret: this.secret } })
      }
    },
    cancelHotelVouchers: function () {
      let dataSend = {
        voucher_ids: _.uniq(_.map(this.PaxsGroup, 'voucher_id')),
        reason: this.cancelReason,
        secret: this.secret
      }

      this.$store
        .dispatch('CancelHotelRoom/cancelHotelVouchers', dataSend)
        .then((response) => {
          this.isOpenPopup = true
          if (response.success) {
            this.pax.has_cancelled_hotel_voucher = 1
            this.confirm = true
            this.cancelHotelVouchersSuccess = true
            this.$set(this.message, 'icon', 'fas fa-check-circle text-success')
            this.$set(this.message, 'text', this.lang['hotel_mobile_new'].SFS_LANG_ROW_84 || 'The hotel voucher is cancelled')
          } else {
            this.notExpiry = false
            this.expiredText = response.message
            this.cancelHotelVouchersSuccess = false
            this.$set(this.message, 'icon', 'far fa-times-circle danger')
            this.$set(this.message, 'text', 'Fail')
          }
        })
        .catch((error) => {
          console.log(error)
          this.isOpenPopup = true
          this.cancelHotelVouchersSuccess = false
          this.$set(this.message, 'icon', 'far fa-times-circle danger')
          this.$set(this.message, 'text', 'Fail')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.title-decline-hotel {
  font-size: 20px;
}
textarea {
  border-radius: 8px;
  resize: none;
}
::v-deep .icon-confirm-success {
  font-size: 20px;
  i {
    font-size: 60px;
  }
}
</style>
